import {SchemaTag} from 'folder-items/FileConstants';
import {StructuredTableColumn} from 'notebook/structured-tables/StructuredTableConstants';
import isColumnForSchemaField from 'notebook/structured-tables/util/isColumnForSchemaField';
import {Cell} from 'notebook/tables/TableConstants';
import {convertTagToTypedValue, EMPTY_TYPED_VALUE} from 'notebook/tables/typed-values/DataTypes';
import {BaseTypedValueType, TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';

import {ProcessTaskStatus} from '../__generated/ProcessTaskStatus';

type CellWithTypedValue = Cell & {typedValue: TypedValue};

export function makeTaskIdCell(task: {id: string; humanId: string}): Cell {
  return {
    text: '',
    typedValue: {
      type: BaseTypedValueType.PROCESS_TASK,
      id: task.id,
      humanId: task.humanId,
    },
  };
}

export function makeOutputIdCell(output: {id: string; humanId: string}): Cell {
  return {
    text: '',
    typedValue: {
      type: BaseTypedValueType.PROCESS_OUTPUT,
      id: output.id,
      humanId: output.humanId,
    },
  };
}

export function makeTaskAssigneeCell(task: {
  assignee: {id: string; handle: string; name: string; avatarUrl: string | null} | null;
}): CellWithTypedValue {
  const {assignee} = task;
  return assignee == null
    ? {text: '', typedValue: EMPTY_TYPED_VALUE}
    : {
        text: '',
        typedValue: {
          type: BaseTypedValueType.USER,
          id: assignee.id,
          avatarUrl: assignee.avatarUrl,
          userHandle: assignee.handle,
          name: assignee.name,
        },
      };
}

export function makeTaskStatusCell(task: {status: ProcessTaskStatus}): CellWithTypedValue {
  return {
    text: '',
    typedValue: {
      type: BaseTypedValueType.TASK_STATUS,
      id: task.status.id,
      displayName: task.status.displayName,
      statusType: task.status.statusType,
    },
  };
}

export function makeTagValueCell(
  {fields}: {fields: Array<SchemaTag>},
  column: StructuredTableColumn
): CellWithTypedValue {
  const targetSchemaTag = fields.find((tag: SchemaTag) => isColumnForSchemaField(column, tag.tagSchemaField));
  return {
    text: '',
    typedValue: targetSchemaTag
      ? convertTagToTypedValue(targetSchemaTag)
      : {type: BaseTypedValueType.STRING, rawValue: ''},
  };
}

export function makeScheduledOnCell({scheduledOnDate}: {scheduledOnDate: string | null}): CellWithTypedValue {
  return scheduledOnDate != null
    ? {
        text: '',
        typedValue: {
          type: BaseTypedValueType.DATE,
          value: scheduledOnDate,
        },
      }
    : {
        text: '',
        typedValue: {
          type: BaseTypedValueType.STRING,
          rawValue: '',
        },
      };
}

export function makeExecutionEntryCell({
  id,
  name,
  editUrl,
}: {
  id: string;
  name: string;
  editUrl: string;
}): CellWithTypedValue {
  return {
    text: '',
    typedValue: {
      type: BaseTypedValueType.ENTRY,
      id,
      name,
      url: editUrl,
    },
  };
}
